export enum FeedbackType {
  Disabled = 'Disabled',
  Zendesk = 'Zendesk',
  MailTo = 'MailTo',
}
